/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Sources_RefillInputs */

const es_admin_billing_sources_refill = /** @type {(inputs: Admin_Billing_Sources_RefillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarga`)
};

const en_admin_billing_sources_refill = /** @type {(inputs: Admin_Billing_Sources_RefillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-up`)
};

/**
* | output |
* | --- |
* | "Top-up" |
*
* @param {Admin_Billing_Sources_RefillInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_sources_refill = /** @type {((inputs?: Admin_Billing_Sources_RefillInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Sources_RefillInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_sources_refill(inputs)
	return en_admin_billing_sources_refill(inputs)
});
export { admin_billing_sources_refill as "admin.billing.sources.refill" }